import { createCRUDHook } from './createCRUDHook';
import { ECG_CategoryDto } from 'utils/models';
import {
  ECG_CATEGORY,
  GET_CATEGORY_DETAILS_BY_ID,
  DELETE_ALL_CATEGORY_DATA_ID,
} from './apiEndPoints';

interface CategoryCustomOperations {
  getCategoryDetailsById: (id: number) => Promise<any>;
  deleteAllCategoryDataId: (id: number) => Promise<boolean>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  ECG_CategoryDto,
  ECG_CategoryDto[],
  CategoryCustomOperations
>({
  entityName: 'Category',
  endpoint: ECG_CATEGORY,

  customOperations: (auth) => ({
    getCategoryDetailsById: async (id: number): Promise<any> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          ECG_CATEGORY + GET_CATEGORY_DETAILS_BY_ID + `?categoryId=${id}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    deleteAllCategoryDataId: async (id: number): Promise<boolean> => {
      try {
        const res = await auth.makeAuthenticatedDelete(
          ECG_CATEGORY + DELETE_ALL_CATEGORY_DATA_ID + `?categoryId=${id}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const CategoryContext = Context;
export const useCategoryManager = useManager;
export const useCategory = useConsumer;
